/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jose P. Guerra",
  title: "Hi all, I'm Jose Pablo",
  subTitle: emoji(
    "A passionate Electronic Engineer 🚀 having an experience in the Machine Learning world, and discovering the Data Science World one data at a time."
  ),
  resumeLink:
    "https://drive.google.com/drive/folders/1Fl-ksdddeShwL1SD5SipqprDrWPEUBp5?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/guerraj97",
  linkedin: "https://www.linkedin.com/in/jose-guerra97",
  gmail: "josepablo-310@hotmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@guerraj_",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "AN ENGINEER WHO WANTS TO EXPLORE THE TECH WORLD AND PASSIONATE ABOUT PROGRAMMING",
  skills: [
    emoji(
      "⚡ Python, C/C++ and Matlab"
    ),
    emoji("⚡ Machine Learnig (Basics) and Computer Vision (Basic)"),
    emoji(
      "⚡ Blockchain enthusiastic"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

softwareSkills: [
  {
    skillName: "Telecommunication Systems",
    fontAwesomeClassname: "fas fa-satellite-dish"
  },
  {
    skillName: "sql-database",
    fontAwesomeClassname: "fas fa-database"
  },
  {
    skillName: "python",
    fontAwesomeClassname: "fab fa-python"
  }
],
display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universidad del Valle de Guatemala",
      logo: require("./assets/images/UVGLogo.png"),
      subHeader: "Electronic Engineering",
      duration: "January 2016 - January 2021",
      desc: "Thesis with honors related with Computer Vision and Swarm Robotic",
      /*descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ] */
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Electronics", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    },
    {
      Stack: "Data Sciencie & Machine Learning",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    /*{
      role: "Technical Service Engineer",
      company: "Krones Automata",
      companylogo: require("./assets/images/kronesLogo.png"),
      date: "Sep 2022 – Present",
      desc: "Technical engineer in charge of maintanance and service for bottlers companys and automatitation industry."
    },*/
    /*{
      role: "Data Analyst Intern",
      company: "Dialogos Guatemala",
      companylogo: require("./assets/images/dialogosLogo.jpeg"),
      date: "Aug 2022 – Present",
      desc: "Data analyst intern to support in different projects of the institution.",
      descBullets: [
        "Working with SQL, Programming, and AI.",
        "Projects focus in social areas."
      ]
    },*/
    {
      role: "Columnist",
      company: "Telegrafo Guatemala",
      companylogo: require("./assets/images/TelegrafoLogo.jpeg"),
      date: "Apr 2022 – Present",
      desc: "Columnist/Blogger in topics related with technologies tendencies and social opinion."
    },
    {
      role: "Field Test Engineer",
      company: "RSI Network",
      companylogo: require("./assets/images/RSILogo.png"),
      date: "Apr 2021 – Sep 2022",
      desc: "Responsible for mechanical construction and electric installation for satelital antennas. Also, test engineer in charge of validate the antenna’s system.",
      descBullets: [
        "Satellite antenna construction (mechanical and electrical)",
        "Projects made in Brewster (WA, USA) and Antartica"
      ]
    },
    {
      role: "Core Engineer Intern",
      company: "Huawei Co, LTD, Guatemala",
      companylogo: require("./assets/images/HuaweiLogo.webp"),
      date: "Jan 2020 – Jul 2020",
      desc: "Seeds for the Future Internship, Guatemala, 2020. Core Network engineer responsible for check and develop projects for telecommunications enterprise in Guatemala."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME PROJECTS I'VE BEEN PART OF",
  projects: [
    {
      image: require("./assets/images/RIES.jpg"),
      projectName: "13m Antenna Construction - McMurdo Station, Antartica",
      projectDesc: "Part of the team who build a 13m antenna for satellite communication for the Ross Island Eart Station (RIES) project on Antartica.",
      footerLink: [
        {
          name: "Ross Island Earth Station Construction Complete",
          url: "https://future.usap.gov/ries-construction-complete/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "13m Antenna Construction - Brewster, WA, USA",
      projectDesc: "Mechanical construction and electrical system installation of a 13m satellite antenna. Support on the DeIce System installation.",
      footerLink: [
        //{
          //name: " ",
          //url: " "
        //}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Some of my certifications and personal achivements.",
  achievementsCards: [
    {
      title: "deeplearning.ai - Coursera",
      subtitle:
        "Certifications in courses such as Sequence Models, Neural Networks and Deep Learning, and Structuring Machine Learning Projects",
      image: require("./assets/images/deepLogo.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/drive/folders/1lyxeDOu5iAMulOvQgNBKKV3UdpcNFr2F?usp=sharing"
        }
      ]
    },
    {
      title: "Thesis approved with Honors",
      subtitle: 
        "Thesis entitled ”Computer Vision Algorithms for Pose Recognition of Agents Using Object-Oriented Programming and Multi-threading” approved with honors for Universidad del Valle de Guatemala.",
      image: require("./assets/images/UVGLogo.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        //{
        //  name: " ",
        //  url: " "
        //}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@guerraj_",
      title: "My Medium Blog",
      description:
        "Read about interesting aplications of Machine Learning, Computer Vision and other programming stuff."
    },
    /*{
      url: "https://elpensadorgt.wordpress.com",
      title: "My Poetry Blog",
      description:
        "If you want to read some poetry, I invite you to check my personal blog (Spanish only)."
  */
 //},
    {
      url: "https://www.amazon.com/-/es/José-Pablo-Guerra-ebook/dp/B0B44S9DXH/ref=sr_1_1?__mk_es_US=ÅMÅŽÕÑ&crid=LERUHFK7AS86&keywords=caso+109&qid=1655306845&s=books&sprefix=caso+109,stripbooks-intl-ship,151&sr=1-1",
      title: "Check my novel: Caso 109",
      description:
        "If you like police novel, and if you want to read a good story, go and buy my novel Caso 109 (Spanish only)."
    },
    {
      url: "https://telegrafo.gt/author/guerraj/",
      title: "Read my blogs at Telegrafo",
      description:
        "As part of my hobbies, I write for this digital media. I invite you to read my publications (Spanish only)."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  //number: "+92-0000000000",
  email_address: "josepablo-310@hotmail.com"
};


// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
